import React, { useEffect, useState } from "react";
import dots from "../assets/images/dots.svg";
import Nav from "./Nav";
import DropdownRight from "./DropdownRight";
import http from "../services/http";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import Dropdown from "react-bootstrap/Dropdown";
import { Modal } from "react-bootstrap";
import { ToastContainer } from "react-toastify";
import { showToast } from "./ShowToast";
import folder from "../assets/images/folder.png";
import { Link } from "react-router-dom";
import { SpinnerCircular } from "spinners-react";
import arrowleft from "../assets/images/arrow-left.png";
import ReactPaginate from "react-paginate";
import arrowright from "../assets/images/arrow-right.png";

export default function Application() {
  const [showModal, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = (id) => {
    setShow(true);
    SelectAnalyst();
    setAnalystId(id);
  };

  const DeactivaeModal = (id, is_deactivated) => {
    setShowDeactiveModal(true);
    setdeactivateId(id);
    setisActivated(is_deactivated);
  };

  const [showModals, setShows] = useState(false);
  const [showModalss, setShowss] = useState(false);
  const [showModalDeactivate, setShowDeactiveModal] = useState(false);
  const [selectedId, setSelectedId] = useState(0);
  const [analystId, setAnalystId] = useState(0);
  const [deactivateId, setdeactivateId] = useState(0);
  const [isActivated, setisActivated] = useState(0);
  const [bucketid, setSelectedBucketId] = useState(0);
  const [video, setVideo] = useState(0);
  const handleCloses = () => setShows(false);
  const handleClosess = () => setShowss(false);
  const handleCloseDeactive = () => setShowDeactiveModal(false);
  const [loading, setLoading] = useState(false);
  const [loadings, setLoadings] = useState(false);
  const [toggle, setToggle] = useState(true);
  const [lastPageNumber, setLastPageNumber] = useState(0);
  const [lastPage, setLastPage] = useState(0);

  const handleShows = (id, practice_video) => {
    setSelectedId(id);
    setVideo(practice_video);
    setShows(true);
  };
  const handleShowsBucket = (id) => {
    setSelectedBucketId(id);
    setShowss(true);
  };

  const [key, setKey] = useState("home");
  const token = localStorage.getItem("xAuthToken");
  const [applicants, setApplicants] = useState([]);
  const [pending, setPending] = useState([]);
  const [cancelled, setCancelled] = useState([]);
  const [selectAnalyst, setSelectAnalyst] = useState([]);
  const [emails, setEmails] = useState([]);
  const [deactivate, setDeactivate] = useState([]);
  const [deleteSpin, setDeleteSpin] = useState(false);

  const [message, setMessage] = useState("");

  useEffect(() => {
    Applicants();
  }, []);

  const DeactivateAnalyst = async () => {
    if (isActivated === 0) {
      console.log("activate api----->", isActivated);
      setDeleteSpin(true);
      http
        .put(`api/admin/analyst/deactivate/${deactivateId}?token=${token}`)
        .then((res) => {
          console.log("analyst", res.data);
          setDeleteSpin(false);
          setShowDeactiveModal(false);
        })
        .catch((error) => {
          setDeleteSpin(false);
        });
    } else {
      console.log("deactivated api----->", isActivated);
      setDeleteSpin(true);
      http
        .put(`api/admin/analyst/activate/${deactivateId}?token=${token}`)
        .then((res) => {
          console.log("analyst", res.data);
          setDeleteSpin(false);
          setShowDeactiveModal(false);
        })
        .catch((error) => {
          setDeleteSpin(false);
        });
    }
  };

  const Applicants = async () => {
    setLoading(true);
    http
      .get(`public/admin/analyst/applicants?token=${token}`)
      .then((res) => {
        console.log("analyst", res.data);

        setApplicants(res.data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };
  // const Deactivate = async () => {
  //   http
  //     .put(`public/admin/analyst/deactivate/${selectedId}?token=${token}`)
  //     .then((res) => {
  //       console.log("deactivate", res.status);
  //       if (res.status === 200) {
  //         handleCloses();

  //         const remData = applicants.filter(function (obj) {
  //           return obj.id !== selectedId;
  //         });
  //         const availableRemData = pending.filter(function (obj) {
  //           return obj.id !== selectedId;
  //         });
  //         const unavailableRemData = cancelled.filter(function (obj) {
  //           return obj.id !== selectedId;
  //         });
  //         setApplicants(remData);
  //         setPending(availableRemData);
  //         setCancelled(unavailableRemData);
  //         selectedId(0);
  //         setMessage(res.data.message);
  //       }
  //     })
  //     .catch((error) => {
  //       console.log("error", error);
  //     });
  // };

  const InProgress = (k) => {
    setKey(k);
    switch (k) {
      case "home":
        setLoading(true);

        http
          .get(`public/admin/analyst/applicants?token=${token}`)
          .then((res) => {
            console.log("analyst", res.data);
            setApplicants(res.data);
            setLoading(false);
          })
          .catch((error) => {
            console.log("error==>", error);
            setLoading(false);
          });
        break;
      case "Completed":
        setLoading(true);

        http
          .get(`public/admin/analyst/cancelled?token=${token}`)
          .then((res) => {
            console.log("cancelled=====>", res.data);
            setCancelled(res.data);
            setLoading(false);
          })
          .catch((error) => {
            console.log(error);
            setLoading(false);
          });
        break;
      case "Deactivated":
        setLoading(true);

        http
          .get(`api/admin/analyst/deactivated?token=${token}`)
          .then((res) => {
            console.log("deactivated=====>", res.data);
            setDeactivate(res.data);
            // setCancelled(res.data);
            setLoading(false);
          })
          .catch((error) => {
            console.log(error);
            setLoading(false);
          });
        break;

      default:
        setLoading(true);

        http
          .get(`public/admin/analyst/pending?token=${token}`)
          .then((res) => {
            console.log("pending=====>", res.data);
            setPending(res.data);
            setLoading(false);
          })
          .catch((error) => {
            console.log("error==>", error);
            setLoading(false);
          });
        break;
    }
  };
  const Rejected = () => {
    http
      .put(`public/admin/analyst/cancel?token=${token}`, {
        id: selectedId,
        is_cancelled: 1,
      })
      .then((res) => {
        console.log("responde cancel===>", res.data);
        showToast("success", res.data.message);

        handleCloses();
      })
      .catch((error) => {
        handleClosess();

        console.log("rejected===>", error.response.data.errors);
        if (error.response) {
          if (error.response.data.errors) {
            for (let key in error.response.data.errors) {
              showToast("error", error.response.data.errors[key]);
              handleClose();
            }
          } else if (error.response.data.message) {
            showToast("error", error.response.data.message);
            handleClose();
          }
        }
      });
  };
  const Rejectedbucket = () => {
    console.log("bucker id");
    http
      .put(`public/admin/analyst/cancel?token=${token}`, {
        id: bucketid,
        is_cancelled: 1,
      })
      .then((res) => {
        console.log("responde cancel===>", res.data);
        showToast("success", res.data.message);

        handleClosess();
      })
      .catch((error) => {
        handleClosess();

        console.log("rejected===>", error.response.data.errors);
        if (error.response) {
          if (error.response.data.errors) {
            for (let key in error.response.data.errors) {
              showToast("error", error.response.data.errors[key]);
              handleClose();
            }
          } else if (error.response.data.message) {
            showToast("error", error.response.data.message);
            handleClose();
          }
        }
      });
  };

  const Approved = () => {
    console.log("selectedId======", selectedId);
    http
      .put(`public/admin/analyst/verification?token=${token}`, {
        id: selectedId,
        is_approved: 1,
      })
      .then((res) => {
        console.log("responde approved===>", res.data);
        showToast("success", res.data.message);

        handleCloses();
      })
      .catch((error) => {
        handleClosess();
        console.log("not approved err===>", error.response.data.errors);
        if (error.response) {
          if (error.response.data.errors) {
            for (let key in error.response.data.errors) {
              showToast("error", error.response.data.errors[key]);
              handleClose();
            }
          } else if (error.response.data.message) {
            showToast("error", error.response.data.message);
            handleClose();
          }
        }
      });
  };

  const SelectAnalyst = async () => {
    http
      .get(`public/admin/analyst/available?token=${token}`)
      .then((res) => {
        console.log("select analyst analyst", res.data);
        setLastPageNumber(res.data.length % usersPerPage);
        setLastPage(Math.ceil(res.data.length / usersPerPage));
        setSelectAnalyst(res.data);
      })
      .catch((error) => {
        console.log("error in analyst");
      });
  };
  const [pageNumber, setPageNumber] = useState(0);

  const usersPerPage = 5;
  const pagesVisited = pageNumber * usersPerPage;
  const pageCountAnalyst = Math.ceil(selectAnalyst.length / usersPerPage);
  const changePage = ({ selected }) => {
    setPageNumber(selected);
  };
  const sendingApi = () => {
    setLoadings(true);
    http
      .post(
        `api/admin/analyst/share/${analystId}?token=${token}`,
        {
          recievers: emails,
        },
        { headers: token }
      )
      .then((res) => {
        console.log("share email", res.data);
        handleClose();
        setLoadings(false);
      })
      .catch((error) => {
        console.log("error---->", error);
        setLoadings(false);
      });
  };

  const handleCheckboxChange = (e, email) => {
    if (e.target.checked === true) {
      const added = [...emails, email];
      setEmails(added);
    } else if (e.target.checked === false) {
      const remEmails = emails.filter((el) => el !== email);
      setEmails(remEmails);
    }
  };

  return (
    <>
      <div className="wrapper">
        <Nav

        // idebarClass={toggle ? "show" : "hide"}
        />
        <div id="content">
          <header>
            <div className="dashboard_header">
              <div className="left-side d-flex ">
                {" "}
                {/*    <button
                  onClick={() => setToggle(!toggle)}
                  type="button"
                  className="btn btn-link  "
                >
                  {" "}
                  <img src={arrowleft} className="img-fluid" />{" "}
                </button> */}
                <h1>Applicants</h1>
              </div>
              <DropdownRight />
            </div>
          </header>
          <div className="dashbord_content">
            <div className="analysts-wraper-head">
              <div className="personal_and_bank_info Analysts_tabs ">
                <Tabs
                  activeKey={key}
                  onSelect={(k) => InProgress(k)}
                  style={{
                    alignItems: "center",
                    width: 637,
                    borderRadius: 5,
                    marginTop: 50,
                    backgroundColor: "#f6f6f6",
                    padding: 10,
                  }}
                  defaultActiveKey="profile"
                  id="uncontrolled-tab-example"
                  className="mb-3 nav nav-pills border-bottom-0"
                >
                  <Tab eventKey="home" title="All" style={{ marginTop: 40 }}>
                    <div className="table_vedio_upload dashbord_table mb_30 mb-0">
                      <table className="table table-borderless table-responsive-md">
                        <thead>
                          <tr>
                            {/* <th scope="col" className="  pl_25">
                              Applicant ID
                            </th> */}
                            <th scope="col" className=" ">
                              Analyst Name
                            </th>
                            <th scope="col" className=" ">
                              Email ID
                            </th>
                            <th scope="col" className=" ">
                              Folder Link
                            </th>
                            <th scope="col" className="  text-center">
                              Status
                            </th>
                            <th scope="col" className="  ">
                              {" "}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {loading ? (
                            <div
                              style={{
                                position: "absolute",
                                marginTop: 250,
                                marginLeft: 580,
                                zIndex: 100,
                              }}
                            >
                              <SpinnerCircular size="15%" />
                            </div>
                          ) : (
                            <>
                              {applicants?.map((item) => (
                                <tr>
                                  {/* <td className="pl_25">{item.id}</td> */}
                                  <td>
                                    {item.firstname} {item.lastname}
                                  </td>
                                  <td>{item.email}</td>
                                  <td>
                                    <a
                                      onClick={() => handleShowsBucket(item.id)}
                                      class="btn-link text-dark"
                                      data-toggle="modal"
                                      data-target="#share_folder"
                                      style={{
                                        border: 0,
                                        marginLeft: 30,
                                        cursor: "pointer",
                                      }}
                                    >
                                      <u>bucket</u>
                                    </a>
                                  </td>
                                  {/*    <td>
                              {" "}
                              {
                                item.practice_video.split("/")[
                                  item.practice_video.split("/").length - 1
                                ]
                              }{" "}
                            </td> */}

                                  <td>
                                    <div className="btn_wraper d-flex justify-content-center  ">
                                      <div className="btn_Subscribed">
                                        {" "}
                                        <button
                                          type="button"
                                          className={
                                            item.is_approved === 1 &&
                                            item.is_cancelled === 0
                                              ? "them_btn_Subscribed"
                                              : !item.is_approved &&
                                                item.is_cancelled
                                              ? "them_btn_Unsubscribed"
                                              : "them_btn_Padding"
                                          }
                                        >
                                          {item.is_approved === 1 &&
                                          item.is_cancelled === 0
                                            ? "Approved"
                                            : !item.is_approved &&
                                              item.is_cancelled
                                            ? "Cancelled"
                                            : "Pending"}
                                        </button>{" "}
                                      </div>
                                    </div>
                                  </td>

                                  <td className="text-center">
                                    <div className="dropdown wraper_btn">
                                      <Dropdown>
                                        <Dropdown.Toggle
                                          className="btn dropdown-toggle"
                                          variant="success"
                                          id="dropdown-basic"
                                        >
                                          <img
                                            src={dots}
                                            className="img-fulid  "
                                          />
                                          <span className="caret"></span>
                                        </Dropdown.Toggle>

                                        <Dropdown.Menu
                                          as="ul"
                                          className="dropul"
                                        >
                                          <Dropdown.Item
                                            to="#/action-1"
                                            as="li"
                                            onClick={() =>
                                              handleShows(
                                                item.id,
                                                item.practice_video
                                              )
                                            }
                                          >
                                            Approve Applicant
                                          </Dropdown.Item>
                                          <Dropdown.Item
                                            to="#/action-2"
                                            as="li"
                                            onClick={() => handleShow(item.id)}
                                          >
                                            Share Applicant
                                          </Dropdown.Item>
                                          <Dropdown.Item
                                            to="#/action-1"
                                            as="li"
                                            onClick={() =>
                                              DeactivaeModal(
                                                item.id,
                                                item.is_deactivated
                                              )
                                            }
                                          >
                                            {item.is_deactivated === 0
                                              ? "Deactivated"
                                              : "Activated"}
                                          </Dropdown.Item>
                                        </Dropdown.Menu>
                                      </Dropdown>
                                    </div>
                                  </td>
                                </tr>
                              ))}
                            </>
                          )}
                        </tbody>
                      </table>
                      <p className="text-table-show">
                        {" "}
                        {/*  Showing 8 out of 132 entries */}
                      </p>
                    </div>
                  </Tab>

                  <Tab
                    onSelect={InProgress}
                    eventKey="Progress"
                    title="Pending"
                    style={{ marginTop: 40 }}
                  >
                    <div className="table_vedio_upload dashbord_table     mb_30  mb-0">
                      <table className="table table-borderless table-responsive-md">
                        <thead>
                          <tr>
                            {/* <th scope="col" className="  pl_25">
                              Analyst ID
                            </th> */}
                            <th scope="col" className=" ">
                              Analyst Name
                            </th>
                            <th scope="col" className=" ">
                              Email ID
                            </th>
                            <th scope="col" className=" ">
                              Cell Number
                            </th>

                            <th scope="col" className="  text-center">
                              Status
                            </th>
                            <th scope="col" className="  ">
                              {" "}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {pending?.map((item) => (
                            <tr>
                              {/* <td className="pl_25">{item.id} </td> */}
                              <td>
                                {" "}
                                {item.firstname} {item.lastname}
                              </td>
                              <td style={{ wordBreak: "break-all" }}>
                                {item.email}
                              </td>
                              <td>{item.phone}</td>

                              <td>
                                <div className="btn_wraper d-flex justify-content-center  ">
                                  <div className="btn_Subscribed">
                                    {" "}
                                    <button
                                      type="button"
                                      className={
                                        item.is_approved === 1 &&
                                        item.is_cancelled === 0
                                          ? "them_btn_Subscribed"
                                          : !item.is_approved &&
                                            item.is_cancelled
                                          ? "them_btn_Unsubscribed"
                                          : "them_btn_Padding"
                                      }
                                    >
                                      {item.is_approved === 1 &&
                                      item.is_cancelled === 0
                                        ? "Approved"
                                        : !item.is_approved && item.is_cancelled
                                        ? "Cancelled"
                                        : "Pending"}
                                    </button>{" "}
                                  </div>
                                </div>
                              </td>
                              <td className="text-center">
                                <div className="dropdown wraper_btn">
                                  <Dropdown>
                                    <Dropdown.Toggle
                                      className="btn dropdown-toggle"
                                      variant="success"
                                      id="dropdown-basic"
                                    >
                                      <img src={dots} className="img-fulid  " />
                                      <span className="caret"></span>
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu as="ul" className="dropul">
                                      <Dropdown.Item
                                        to="#/action-1"
                                        as="li"
                                        onClick={() => handleShows(item.id)}
                                      >
                                        Approve Applicant
                                      </Dropdown.Item>
                                      <Dropdown.Item
                                        to="#/action-2"
                                        as="li"
                                        onClick={() => handleShow(item.id)}
                                      >
                                        Share Applicant
                                      </Dropdown.Item>
                                    </Dropdown.Menu>
                                  </Dropdown>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      <p className="text-table-show">
                        {" "}
                        {/*  Showing 8 out of 132 entries */}
                      </p>
                    </div>
                  </Tab>
                  <Tab
                    eventKey="Completed"
                    title="Cancelled"
                    style={{ marginTop: 40 }}
                  >
                    <div className="table_vedio_upload dashbord_table     mb_30  mb-0">
                      <table className="table table-borderless table-responsive-md">
                        <thead>
                          <tr>
                            {/* <th scope="col" className="  pl_25">
                              Analyst ID
                            </th> */}
                            <th scope="col" className=" ">
                              Analyst Name
                            </th>
                            <th scope="col" className=" ">
                              Email ID
                            </th>
                            <th scope="col" className=" ">
                              Cell Number
                            </th>

                            <th scope="col" className="  text-center">
                              Status
                            </th>
                            <th scope="col" className="  ">
                              {" "}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {cancelled?.map((item) => (
                            <tr>
                              {/* <td className="pl_25">{item.id} </td> */}
                              <td>
                                {" "}
                                {item.firstname} {item.lastname}
                              </td>
                              <td style={{ wordBreak: "break-all" }}>
                                {item.email}
                              </td>
                              <td>{item.phone}</td>

                              <td>
                                <div className="btn_wraper d-flex justify-content-center  ">
                                  <div className="btn_Subscribed">
                                    {" "}
                                    <button
                                      type="button"
                                      className={
                                        item.is_approved === 1 &&
                                        item.is_cancelled === 0
                                          ? "them_btn_Subscribed"
                                          : !item.is_approved &&
                                            item.is_cancelled
                                          ? "them_btn_Unsubscribed"
                                          : "them_btn_Padding"
                                      }
                                    >
                                      {item.is_approved === 1 &&
                                      item.is_cancelled === 0
                                        ? "Approved"
                                        : !item.is_approved && item.is_cancelled
                                        ? "Cancelled"
                                        : "Pending"}
                                    </button>{" "}
                                  </div>
                                </div>
                              </td>
                              <td className="text-center">
                                {/*  <img
                                  src={dots}
                                  // className="img-fulid  "
                                  onClick={() => handleShows(item.id)}
                                /> */}
                                <div className="dropdown wraper_btn">
                                  <Dropdown>
                                    <Dropdown.Toggle
                                      className="btn dropdown-toggle"
                                      variant="success"
                                      id="dropdown-basic"
                                    ></Dropdown.Toggle>
                                  </Dropdown>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      <p className="text-table-show"></p>
                    </div>
                  </Tab>
                  <Tab
                    eventKey="Deactivated"
                    title="Deactivated"
                    style={{ marginTop: 40 }}
                  >
                    <div className="table_vedio_upload dashbord_table     mb_30  mb-0">
                      <table className="table table-borderless table-responsive-md">
                        <thead>
                          <tr>
                            {/* <th scope="col" className="  pl_25">
                              Analyst ID
                            </th> */}
                            <th scope="col" className=" ">
                              Analyst Name
                            </th>
                            <th scope="col" className=" ">
                              Email ID
                            </th>
                            <th scope="col" className=" ">
                              Cell Number
                            </th>

                            <th scope="col" className="  text-center">
                              Status
                            </th>
                            <th scope="col" className="  ">
                              {" "}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {deactivate?.map((item) => (
                            <tr>
                              {/* <td className="pl_25">{item.id} </td> */}
                              <td>
                                {" "}
                                {item.firstname} {item.lastname}
                              </td>
                              <td style={{ wordBreak: "break-all" }}>
                                {item.email}
                              </td>
                              <td>{item.phone}</td>

                              <td>
                                <div className="btn_wraper d-flex justify-content-center  ">
                                  <div className="btn_Subscribed">
                                    {" "}
                                    <button
                                      type="button"
                                      className={
                                        item.is_approved === 1 &&
                                        item.is_cancelled === 0
                                          ? "them_btn_Unsubscribed"
                                          : !item.is_approved &&
                                            item.is_cancelled
                                          ? "them_btn_Unsubscribed"
                                          : "them_btn_Unsubscribed"
                                      }
                                    >
                                      {item.is_approved === 1 &&
                                      item.is_cancelled === 0
                                        ? "deactivated"
                                        : !item.is_approved && item.is_cancelled
                                        ? "deactivated"
                                        : "deactivated"}
                                    </button>{" "}
                                  </div>
                                </div>
                              </td>
                              <td className="text-center">
                                {/*  <img
                                src={dots}
                                // className="img-fulid  "
                                onClick={() => handleShows(item.id)}
                              /> */}
                                <div className="dropdown wraper_btn">
                                  <Dropdown>
                                    <Dropdown.Toggle
                                      className="btn dropdown-toggle"
                                      variant="success"
                                      id="dropdown-basic"
                                    ></Dropdown.Toggle>
                                  </Dropdown>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      <p className="text-table-show"></p>
                    </div>
                  </Tab>
                </Tabs>
              </div>

              <Modal
                className="starrating"
                show={showModal}
                onHide={handleClose}
              >
                <div
                  class=" starrating share_table"
                  id="share_table"
                  data-backdrop="static"
                  data-keyboard="false"
                  tabindex="-1"
                  aria-labelledby="share_table"
                  aria-hidden="true"
                >
                  <div class=" modal-dialog-centered">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 class="modal-title" id="share_table">
                          ID: {analystId}
                        </h5>
                        <button
                          onClick={handleClose}
                          type="button"
                          class="close ml-0"
                          data-dismiss="modal"
                          aria-label="Close"
                        >
                          {" "}
                          <span aria-hidden="true">&times;</span>{" "}
                        </button>
                      </div>
                      <div class="modal-bodys">
                        <h5 class="modal-title mb-3" style={{ padding: 10 }}>
                          Select Analysts
                        </h5>
                        <div class="table_vedio_upload dashbord_table     mb_30 over_flow mb-0">
                          <table class="table table-borderless">
                            <thead>
                              <tr>
                                <th class="pl_25"></th>
                                {/* <th scope="col">ID</th> */}
                                <th scope="col" class=" ">
                                  {" "}
                                  Name
                                </th>
                                <th scope="col" class="  text-center">
                                  Status
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {selectAnalyst
                                .slice(
                                  pagesVisited,
                                  pagesVisited + usersPerPage
                                )
                                ?.map((item) => (
                                  <tr>
                                    <td
                                      class="pl_25"
                                      style={{ wordBreak: "break-all" }}
                                    >
                                      <label class="check_box">
                                        <input
                                          type="checkbox"
                                          onChange={(e) =>
                                            handleCheckboxChange(e, item.email)
                                          }
                                        />
                                        <span class="checkmark"></span>{" "}
                                      </label>
                                    </td>
                                    {/* <td>{item.id}</td> */}
                                    <td>
                                      {item.firstname} {item.lastname}
                                    </td>
                                    <td>
                                      <div class="btn_wraper d-flex justify-content-center  ">
                                        <div class="btn_Subscribed">
                                          <button
                                            type="button"
                                            class="them_btn_Subscribed   "
                                          >
                                            Available
                                          </button>
                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </div>
                        <div class="modal-footer border-top-0">
                          <div class="nav_list ">
                            <div className="application-pagination">
                              <ReactPaginate
                                previousLabel={""}
                                nextLabel={<img src={arrowright} />}
                                pageCount={pageCountAnalyst}
                                onPageChange={changePage}
                                containerClassName={"pagination_btn"}
                                previousLinkClassName={"previousBttn"}
                                nextLinkClassName={"nextBttn"}
                                disabledClassName={"paginationDisabled"}
                                activeClassName={"paginationActive"}
                              />
                            </div>
                          </div>

                          <div class="btn_footer d-flex ">
                            <button
                              onClick={handleClose}
                              type="button"
                              class="them_btn_ouline mr-2"
                            >
                              Cancel
                            </button>
                            <button
                              type="button"
                              class="them_btn "
                              onClick={sendingApi}
                            >
                              {loadings ? (
                                <SpinnerCircular
                                  style={{ height: "40", marginTop: "7" }}
                                />
                              ) : (
                                "Send"
                              )}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Modal>

              <Modal
                className="starrating"
                show={showModals}
                onHide={handleClosess}
                centered
              >
                <Modal.Header>
                  <Modal.Title as="h5">ID: {selectedId}</Modal.Title>
                  <button
                    onClick={handleCloses}
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    {" "}
                    <span aria-hidden="true">&times;</span>{" "}
                  </button>
                </Modal.Header>
                <Modal.Body>
                  <video
                    style={{
                      width: 100,
                      height: 80,
                      marginLeft: 150,
                    }}
                    src={video}
                  />
                  <div className="modal-footer border-top-0">
                    {" "}
                    <button
                      type="button"
                      className="them_btn1"
                      onClick={Rejected}
                    >
                      Reject
                    </button>{" "}
                    <button
                      type="button"
                      className="them_btn1 "
                      onClick={Approved}
                    >
                      Approve
                    </button>{" "}
                  </div>
                </Modal.Body>
              </Modal>
            </div>
          </div>
        </div>
      </div>

      <ToastContainer />
      <Modal
        className="starrating"
        show={showModalss}
        onHide={handleClosess}
        centered
      >
        <Modal.Body style={{ padding: 0.1 }}>
          <div class="starrating modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="share_folder">
                ID: {bucketid}
              </h5>

              <button type="button" class="close ml-0" onClick={handleClosess}>
                {" "}
                <span aria-hidden="true">&times;</span>{" "}
              </button>
            </div>
            <div class="modal-body" style={{ padding: "0.2rem" }}>
              <div class="raing_star">
                <div class="uplode_file_show uplode_folder ">
                  {" "}
                  <img src={folder} alt="" />
                  <Link to="/bucketVideos" state={{ id: bucketid }}>
                    <h5>Show bucket</h5>
                  </Link>
                </div>
              </div>
              <div class="modal-footer border-top-0">
                <button
                  type="button"
                  class="them_btn_ouline "
                  onClick={Rejectedbucket}
                >
                  Reject
                </button>

                <button type="button" class="them_btn1 " onClick={Approved}>
                  Approve
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="starrating"
        show={showModalDeactivate}
        onHide={handleCloseDeactive}
        centered
      >
        <Modal.Header>
          <Modal.Title as="h5">Are you sure?</Modal.Title>
          <button
            onClick={handleCloseDeactive}
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            {" "}
            <span aria-hidden="true">&times;</span>{" "}
          </button>
        </Modal.Header>
        <Modal.Body>
          <div class="raing_star">
            <p>Are you sure you want to Deactivate.</p>
          </div>
          <div className="modal-footer border-top-0">
            <button
              onClick={handleCloseDeactive}
              type="button"
              className=" them_btn_ouline  "
            >
              Cancel
            </button>
            <button
              onClick={DeactivateAnalyst}
              type="button"
              className="them_btn1 "
              data-toggle="modal"
              data-target="#new_team_add_yes"
            >
              {deleteSpin ? <SpinnerCircular /> : "    Yes"}
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
